import { AwarenessUser } from "./types";
import { WebsocketProvider } from "@y-rb/actioncable";

export function getAwarenessUsers(
  provider: WebsocketProvider,
  options: { unique?: boolean } = { unique: true}
): AwarenessUser[] {
  const users =  Array.from(provider.awareness.getStates().values()) as AwarenessUser[];
  if(options.unique) {
    return getUniqueAwarenessUsers(users);
  }
  return users;
}

export function getUniqueAwarenessUsers(
  users: AwarenessUser[]
): AwarenessUser[] {
  return users.filter((user, index, self) => {
    return self.findIndex((u) => u.id === user.id) === index;
  });
}
